import { useState } from "react";
import { Grid, Link, Stack, IconButton } from "@mui/material";
import logo from "../../assets/images/logo.png";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import TwitterIcon from "@mui/icons-material/Twitter";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { useNavigate } from "react-router-dom";
import headerConstants from "../../utils/headerConstant.json";

interface InfoProps {
  phone: number;
  email1: string;
  email2: string;
  email3: string;
  address: string;
}

const Header = () => {
  const [headers, setHeaders] = useState<InfoProps>(headerConstants.headers);
  const navigate = useNavigate();

  return (
    <Grid
      container
      id="back-to-top-anchor"
      alignItems="center"
      justifyContent="space-between"
      sx={{
        backgroundColor: "secondary.light",
        p: { xs: 1, md: 2 },
        height: "auto",
        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
        borderBottom: "1px solid",
        borderColor: "divider",
      }}
    >
      <Grid item xs={12} md={3} sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Stack direction="row" spacing={1} alignItems="center" sx={{maxWidth: { xs: "80%", sm: "90%", md: "100%" }}}>
          <img src={logo} alt="logo" style={{ maxWidth: "100%", cursor:'pointer' }}
          onClick={() => navigate("/")} />
        </Stack>
      </Grid>

      <Grid item xs={12} md={6}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >
        <Stack direction="row" alignItems="flex-start" spacing={2}>
          {/* Social Icons */}
          <Stack
            direction="row"
            alignItems="flex-end"
            spacing={1}
            sx={{ display: { xs: "none", md: "flex" }, alignItems: "start" }}
          >
            <IconButton
              aria-label="Facebook"
              size="small"
              sx={{
                color: "white",
                backgroundColor: "#3b5998",
                ":hover": {
                  backgroundColor: "#2d4373",
                },
              }}
            >
              <FacebookOutlinedIcon />
            </IconButton>
            <IconButton
              aria-label="Twitter"
              size="small"
              sx={{
                color: "white",
                backgroundColor: "#55ACEE",
                ":hover": {
                  backgroundColor: "#1a8cd8",
                },
              }}
            >
              <TwitterIcon />
            </IconButton>
            <IconButton
              aria-label="LinkedIn"
              size="small"
              sx={{
                color: "white",
                backgroundColor: "#0077B5",
                ":hover": {
                  backgroundColor: "#005582",
                },
              }}
            >
              <LinkedInIcon />
            </IconButton>
          </Stack>

          {/* Contact Information */}
          <Stack
            direction="column"
            spacing={0.5}
            alignItems="flex-start"
            sx={{ display: { xs: "none", md: "flex" } }}
          >
            <Stack direction="row" alignItems="center" spacing={0.5}>
              <PhoneIcon sx={{ color: "secondary.main" }} />
              <Link
                href={`tel:+91${headers.phone}`}
                underline="hover"
                color="primary.main"
              >
                {headers.phone}
              </Link>
            </Stack>
            <Stack direction="row" alignItems="center" spacing={0.5}>
              <EmailIcon sx={{ color: "secondary.main" }} />
              <Link
                href={`mailto:${headers.email1}`}
                underline="hover"
                color="primary.main"
              >
                {headers.email1}
              </Link>
            </Stack>
          </Stack>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default Header;
